import React, { useEffect, useState, memo } from 'react'
import { Grid } from '@material-ui/core/'
import { Meetings, Users, All, Stories } from './Components'
import c from 'classnames'
import './index.scss'

const Analytics = ({ typePage, setTypePage }) => {
  const [startCategory, setStartCategory] = useState(0)
  const titleCategory = ['ALL', 'USERS', 'MEETINGS FEEDBACK', 'STORIES']
  const categoryAnalytics = {
    0: () => <All />,
    1: () => <Users />,
    2: () => <Meetings />,
    3: () => <Stories />,
  }

  const content = categoryAnalytics?.[startCategory] || categoryAnalytics?.[0]

  useEffect(() => {
    if (typePage) {
      setStartCategory(typePage)
      setTypePage(null)
    }
  }, [typePage])

  return (
    <Grid className='wrapperAnalytics'>
      <Grid className='headerNavAnalytics'>
        <Grid className='boxNavItem'>
          {titleCategory?.map((i, ind) => (
            <Grid onClick={() => setStartCategory(ind)} key={i} className={c('itemNav', startCategory === ind && 'activeItem')}>
              {i}
            </Grid>
          ))}
        </Grid>
      </Grid>
      {content()}
    </Grid>
  )
}

export default memo(Analytics)
